export const GET_DIVISIONS_WATCHER =
  "app/WidgetResultByDivisionEngagement/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS =
  "app/WidgetResultByDivisionEngagement/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED =
  "app/WidgetResultByDivisionEngagement/GET_DIVISIONS_FAILED"
